import React from "react";
import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";

import { setRangeSelectParams } from "@/src/store/filter";

import { numberFormatter } from "@/src/helpers/number-formatter";
import { onlyNumber } from "helpers/only-number";

import Input from "@/src/components/common/input";

import styles from "@/src/components/listing-search/filter-items/styles.module.css";

const MinMaxInput = ({ filter, filterKey }) => {
  const reduxRangeItems = useSelector((state) => state.filter.rangeselectitems);

  const dispatch = useDispatch();

  const handleChangeRangeInput = (filterKey, type, event) => {
    const newValue = event.target.value?.replaceAll(".", "");
    if (!onlyNumber(newValue) && newValue !== "") return;
    const findParams = reduxRangeItems?.find((item) => item.key === filterKey) || {};

    const filterObject = {
      key: filterKey,
      value: {
        min: type === "min" ? newValue : findParams?.value?.min,
        max: type === "max" ? newValue : findParams?.value?.max,
      },
    };

    const newCriteriaParams = reduxRangeItems?.filter((item) => item.key !== filterKey);
    newCriteriaParams.push(filterObject);
    dispatch(setRangeSelectParams(newCriteriaParams));
  };

  const minValue = numberFormatter(reduxRangeItems.find((item) => item.key === filterKey)?.value?.min) || "";
  const maxValue = numberFormatter(reduxRangeItems.find((item) => item.key === filterKey)?.value?.max) || "";

  return (
    <div className={styles.priceInputWrapper}>
      <div className={styles.minMaxInputWrapper}>
        <Input
          placeholder="Min"
          value={minValue}
          onChange={(event) => handleChangeRangeInput(filterKey, "min", event)}
          inputClass={styles.minMaxInput}
        />
      </div>

      <span className={styles.textAlto}>-</span>
      <div className={styles.minMaxInputWrapper}>
        <Input
          placeholder="Max"
          value={maxValue}
          onChange={(event) => handleChangeRangeInput(filterKey, "max", event)}
          inputClass={styles.minMaxInput}
        />
      </div>
    </div>
  );
};

MinMaxInput.propTypes = {
  filter: PropTypes.object,
  filterKey: PropTypes.string,
};

export default MinMaxInput;
